import { toastr } from 'react-redux-toastr';
import Logger from 'logger';

export const HANDLE_SERVER_EXCEPTION = 'HANDLE_SERVER_EXCEPTION';

function requestHandleServerException(exceptionResponse) {
  return {
    type: HANDLE_SERVER_EXCEPTION,
    ...exceptionResponse
  };
}

export function handleServerException(exceptionResponse, callbackActionCreator, showAlert) {
  if (exceptionResponse.data && exceptionResponse.data.code === 401) {
    console.error('API request: Unauthorized');
  } else {
    console.error('Exception from server', exceptionResponse.data);
    Logger.error({
      message: `API request error: ${ (exceptionResponse && exceptionResponse.data && exceptionResponse.data.message) || 'Unknown exception' }`,
      request: {
        method: exceptionResponse.config && exceptionResponse.config.method,
        URL: exceptionResponse.config && exceptionResponse.config.url,
        data: exceptionResponse.config && exceptionResponse.config.data
      },
      response: {
        ...exceptionResponse.data
      },
      type: 'API_REQUEST'
    });
  }
  return (dispatch) => {
    if (showAlert) {
      toastr.error(
        'Error',
        exceptionResponse.data && exceptionResponse.data.message
          ? exceptionResponse.data.message
          : "Something's not quite right. Please try again or speak to your system administrator."
      );
    }
    if (callbackActionCreator && typeof callbackActionCreator === 'function') {
      return dispatch(callbackActionCreator(exceptionResponse.data));
    }
    return dispatch(requestHandleServerException(exceptionResponse));
  };
}
